module.exports = __webpack_public_path__ + "static/media/amex.fe260bf8.svg";